import { render, staticRenderFns } from "./VgButtonGroup.vue?vue&type=template&id=3cc8446a&scoped=true&"
import script from "./VgButtonGroup.vue?vue&type=script&lang=js&"
export * from "./VgButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./VgButtonGroup.vue?vue&type=style&index=0&id=3cc8446a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc8446a",
  null
  
)

export default component.exports